import React, { useContext } from "react"
import { RootContext } from "RootContext"

// Core components
import IconButton from "@material-ui/core/IconButton"
import Tooltip from "@material-ui/core/Tooltip"
import InputIcon from '@material-ui/icons/Input'

// Button che apre la finestra con i dati del Job
function ButtonDialogJob(props) {
  const { handleClickOpen, year, job } = props
  const { t, isLabUser, getJobToBlockerActive } = useContext(RootContext)

  let seeButton = false

  // Solo utente laboratorio con scope 22 attivo vede il bottone
  if (isLabUser()) {
    seeButton = getJobToBlockerActive()
  }

  return seeButton ? (
    <div>
      <Tooltip title={t("10439")}>
        <IconButton
          aria-label={t("10439")}
          variant="outlined"
          onClick={() => {
            handleClickOpen(year, job)
          }}
        >
          <InputIcon />
        </IconButton>
      </Tooltip>
    </div>
  ) : null
}

function JobToBlockerButton(props) {
  return (
    <div id="contenitore">
      <ButtonDialogJob {...props} />
    </div>
  )
}

export default JobToBlockerButton
